import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoreContainerComponent } from './core/core-container/core-container.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DeviceComponent } from './device/device.component';
import { SliderComponent } from './slider/slider.component';
import { PreferenceComponent } from './preference/preference.component';
import { DriverComponent } from './driver/driver.component';
import { TestComponent } from './test/test.component';
import { Test2Component } from './test2/test2.component';
import { VehicleComponent } from './vehicle/vehicle.component';
import { UserComponent } from './user/user.component';
import { UserCoreContainerComponent } from './user-side/user-core/user-core-container/user-core-container.component';
import { UserSideModule } from './user-side/user-side.module';
import { CompanyModule } from './company/company.module';
import { CompanypartnerComponent } from './company/companypartner/companypartner.component';
import { CompanyuserComponent } from './company/companyuser/companyuser.component';
import { LoginComponent } from './login';
import { AuthGuard } from './_helpers';
import { Role } from './_models';
import { UserAlarmEventsComponent } from './user-side/user-alarm-events/user-alarm-events.component';
import { UserAlarmAccidentComponent } from './user-side/user-alarm-accident/user-alarm-accident.component';
import { ReportComponent } from './user-side/report/report.component';
import { AddFavorisReportComponent } from './user-side/add-favoris-report/add-favoris-report.component';
import { PlannificationReportComponent } from './user-side/plannification-report/plannification-report.component';
import { ReportHistoryComponent } from './user-side/report-history/report-history.component';
import { UserVehiculeDetailsContainerComponent } from './user-side/user-vehicle/user-vehicule-details/user-vehicule-details-container/user-vehicule-details-container.component';
import { UserVehiculeDetailsEventsComponent } from './user-side/user-vehicle/user-vehicule-details/user-vehicule-details-events/user-vehicule-details-events.component';
import { UserVehiculeDetailsScoresComponent } from './user-side/user-vehicle/user-vehicule-details/user-vehicule-details-scores/user-vehicule-details-scores.component';
import { UserVehiculeDetComponent } from './user-side/user-vehicle/user-vehicule-details/user-vehicule-det/user-vehicule-det.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ProfilComponent } from './profil/profil.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import {NewLoginComponent} from "./newComponents/new-login/new-login.component";


const routes: Routes = [

  {path: 'newLogin' , component: NewLoginComponent},

  {path: '404' , component: ErrorPageComponent},

  {path: 'login' , component: NewLoginComponent,},
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {path: 'slide' , component: SliderComponent},

  { path: 'test2', component: LoginComponent },
  {path: 'user/reset/:id' , component: ResetPasswordComponent},

  {path: 'admin' , component: CoreContainerComponent,  canActivate: [AuthGuard],data: { roles: [Role.Admin]} ,children: [
    {path: 'dashboard' , component: DashboardComponent , canActivate: [AuthGuard],data: { roles: [Role.Admin]}},

    {path: 'device' , component: DeviceComponent, canActivate: [AuthGuard],data: { roles: [Role.Admin]}},

    {path: 'preference' , component: PreferenceComponent, canActivate: [AuthGuard],data: { roles: [Role.Admin]}},
    {path: 'driver' , component: DriverComponent, canActivate: [AuthGuard],data: { roles: [Role.Admin]}},
    {path: 'vehicule' , component: VehicleComponent, canActivate: [AuthGuard],data: { roles: [Role.Admin]}},
    {path: 'test/:id' , component: TestComponent},
    {path: 'user' , component: UserComponent, canActivate: [AuthGuard],data: { roles: [Role.Admin]}},
    {path:"companypartner" , component: CompanypartnerComponent, canActivate: [AuthGuard],data: { roles: [Role.Admin]}},
    {path:"companyuser/:id/:id/:id" , component: CompanyuserComponent, canActivate: [AuthGuard],data: { roles: [Role.Admin]}},

  ]},


  { path: 'user',  loadChildren: () => UserSideModule  },
  {path: 'user' , component: UserCoreContainerComponent, children: [
  ]},
  {path: "vehiculeDetails" , component: UserVehiculeDetailsContainerComponent, children: [
    { path: '', loadChildren: () => UserSideModule  },


  ]},





];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
